import React, { useEffect, useRef, useState } from 'react'
import { FaGamepad } from 'react-icons/fa'
import { IoMdFootball } from 'react-icons/io'
import { MdAdd, MdBlock, MdCreate, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'
import _constantUtil from '../../utils/Constant'
import ReactPaginate from 'react-paginate' 
import { Tooltip } from 'react-tooltip'
import icon from '../../assets/sports-football-icon-25.png'

function AllCategory() { 
    const [page, setPage] = useState(_constantUtil.ONE);
    const [totalPages, setTotalPages] = useState(_constantUtil.ZERO);
    const [confirmation, setConfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
    const [updateconfirmation, setUpdateconfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
    const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
    const confirmationRef = useRef(_constantUtil.NULL);
    const [icons, setIcons] = useState(icon)

    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
            setConfirmation(_constantUtil.BOOLEAN_FALSE);
            setUpdateconfirmation(_constantUtil.BOOLEAN_FALSE)
            setShowConfirmation(_constantUtil.BOOLEAN_FALSE)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };    
    }, []); 

    const handleImageChange = (event) => {
    const file = event.target.files[_constantUtil.ZERO];
    if (file) {
        const reader = new FileReader();
        reader.onload = () => {
        setIcons(reader.result);
        };
        reader.onerror = (error) => {
        console.error("Error reading file:", error);
        };
        reader.readAsDataURL(file);
    }
    };
    
  return (
    <>
        {showConfirmation && (
          <div>
            <div className='confirmation-overlay'></div>
            <div ref={confirmationRef} className='confirmation-dialog'>
              <p>Are you sure to update sports status ?</p>
              <div className='d-flex justify-content-end '>
                <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                <button className='border-0 rounded px-3 bg-success text-white p-2 me-0' > Confirm  </button>
              </div>
            </div>
          </div>
        )} 

        {confirmation && (
            <div>
            <div className='team-confirmation-overlay'></div>
            <div ref={confirmationRef} className='match-light-confirmation-dialog'>
                <h4>Add Sports</h4>
                <hr className='hr-color'/>
                <form> 
                    <div className="row">   
                        <div className='col-12 col-md-6 my-auto  '>
                            <label htmlFor='sports_name' className='form-label fw-semibold'>
                                Name
                            </label>
                            <input
                            type='text'
                            className='form-control w-100 my-auto' 
                            id='sports_name'
                            name='name' 
                            placeholder='Enter Sports Name'
                            autoComplete='off'
                            /> 
                        </div>

                        <div className=" col-12  col-md-6 text-center sports-image">
                            <img
                            src={icons}
                            alt='Profile'
                            className='img-thumbnail img-fluid '
                            style={{
                                borderRadius: '50%',
                                cursor: 'pointer',
                                objectFit: 'cover',
                                minHeight: '110px',
                                height: '110px',
                                maxWidth: '110px',
                                width: '110px',
                                backgroundColor: 'white'
                            }}
                            /> 
                            <div className='button-wrapper pt-2 mt-2'>
                                <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                                <div className="d-flex justify-content-center">
                                <input
                                    type='file'
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleImageChange} 
                                    className=' upload-box form-control' 
                                    name='upload' 
                                    id='upload-modal'
                                    placeholder='Upload File'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='hr-color'/>
                    <div className='d-flex justify-content-end mt-3'>
                        <button onClick={()=>setConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
                        <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
                    </div>
                </form>
            </div>
            </div>   
        )}  
        
        {updateconfirmation && (
            <div>
            <div className='team-confirmation-overlay'></div>
            <div ref={confirmationRef} className='match-light-confirmation-dialog'>
                <h4>Update Sports</h4>
                <hr className='hr-color'/>
                <form> 
                    <div className="row">   
                        <div className='col-12 col-md-12 col-lg-6 my-auto  '>
                            <label htmlFor='sports_name' className='form-label fw-semibold'>
                                Name
                            </label>
                            <input
                            type='text'
                            className='form-control w-100 my-auto' 
                            id='sports_name'
                            name='name' 
                            placeholder='Enter Sports Name'
                            autoComplete='off'
                            /> 
                        </div>

                        <div className=" col-12  col-md-12 col-lg-6 text-center sports-image">
                            <img
                            src={icons}
                            alt='Profile'
                            className='img-thumbnail img-fluid '
                            style={{
                                borderRadius: '50%',
                                cursor: 'pointer',
                                objectFit: 'cover',
                                minHeight: '110px',
                                height: '110px',
                                maxWidth: '110px',
                                width: '110px',
                                backgroundColor: 'white'
                            }}
                            /> 
                            <div className='button-wrapper pt-2 mt-2'>
                                <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                                <div className="d-flex justify-content-center">
                                <input
                                    type='file'
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleImageChange} 
                                    className=' upload-box form-control' 
                                    name='upload' 
                                    id='upload-modal'
                                    placeholder='Upload File'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='hr-color'/>
                    <div className='d-flex justify-content-end mt-3'>
                        <button onClick={()=>setUpdateconfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
                        <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
                    </div>
                </form>
            </div>
        </div>   
        )}  
      
        <div className='px-4 mt-4'>
            <div className='container-fluid p-0'>
                <div className='row'>
                    <h4 className='header-title pb-3 text-muted'>All Sports</h4>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <div className='d-flex'> 
                                        <input
                                            type='text'
                                            className='form-control me-2'
                                            id='search'
                                            name='search'
                                            placeholder='Search...' 
                                            autoComplete='off'
                                        />
                                    </div>
                                    <div className='d-flex '>
                                        <div className=''>
                                            <button
                                                type='button'
                                                className='btn jumbo-bg-dull-sky text-white'
                                                onClick={() => setConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                            > 
                                            <MdAdd className='fs-5 me-1 mb-1 ' />
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div> 
                                <div className='table-responsive'>
                                    <table
                                    id='scroll-horizontal-datatable'
                                    className='table w-100 nowrap'
                                    >
                                        <thead>
                                            <tr>
                                            <th>SN</th>  
                                            <th>Profile</th> 
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr>
                                                <th scope='row'>1</th>  
                                                <td>
                                                    <FaGamepad className='fs-4'/>
                                                </td>
                                                <td>Esports</td>
                                                <td> 
                                                    <span className='badge badge-success-lighten'>ACTIVE</span>  
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate
                                                            data-tooltip-id='updatecategory' data-tooltip-content="Update Sports"
                                                            className=' jumbo-icon  me-2 fs-5 jumbo-icon' style={{cursor: 'pointer', color:'gray'}} 
                                                            onClick={()=>setUpdateconfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='updatecategory' place="bottom" effect="solid"/>  

                                                        <MdBlock
                                                            data-tooltip-id='inctive' data-tooltip-content="Inactive Sports"
                                                            className='jumbo-icon pointer user-status fs-5 me-2 text-danger' style={{cursor: 'pointer'}}   
                                                            onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='inctive' place="bottom" effect="solid"/>
                                                    </div>
                                                </td> 
                                            </tr>  
                                            <tr>
                                                <th scope='row'>2</th>  
                                                <td>
                                                    <IoMdFootball className='fs-4'/>
                                                </td>
                                                <td>American Football</td>
                                                <td> 
                                                    <span className='badge badge-danger-lighten'>INACTIVE</span>  
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate
                                                            data-tooltip-id='updatecategory' data-tooltip-content="Update Sports"
                                                            className=' jumbo-icon  me-2 fs-5 jumbo-icon' style={{cursor: 'pointer', color:'gray'}} 
                                                            onClick={()=>setUpdateconfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='updatecategory' place="bottom" effect="solid"/>  

                                                        <MdBlock
                                                            data-tooltip-id='inctive' data-tooltip-content="Inactive Sports"
                                                            className='jumbo-icon pointer user-status fs-5 me-2 text-danger' style={{cursor: 'pointer'}}   
                                                            onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='inctive' place="bottom" effect="solid"/>
                                                    </div>
                                                </td> 
                                            </tr> 
                                        </tbody>
                                    </table>                    
                                </div>
                                <ReactPaginate
                                    className='pagination'
                                    onPageChange={(selectedPage) => { setPage(selectedPage.selected + 1) }}
                                    pageCount={totalPages}
                                    previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                    nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                    breakLabel={'...'}
                                    containerClassName={'pagination-container'}
                                    activeClassName={'pagination-active-page'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AllCategory
